<template>
  <div class="filter-left">
    <div style="margin-right: 8px; z-index: 5">
      <Dropdown @on-click="selectApp" class="filter-appselecter">
        <i-button type="default" shape="circle" class="filter-appselecter-ctrl">
          <img :src="selectedApp.icon" />
          <span>{{ selectedApp.productname || '加载中...' }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </i-button>
        <Dropdown-menu slot="list" class="filter-appselecter-list">
          <Dropdown-item
            v-for="(item, index) in productList"
            :name="index"
            :key="index"
            class="filter-appselecter-item"
          >
            <img :src="item.icon" />
            <span class="filter-content" :title="item.productname">{{ item.productname }}</span>
          </Dropdown-item>
        </Dropdown-menu>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import BaseLib from '../../base/BaseLib';
import AnalyticsPublic from '../../base/AnalyticsPublic';
import StateHandler from '../../base/StateHandler';
export default {
  name: 'SelectApp',
  components: {},
  props: {
    ownProduct: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      productList: [],
      selectedApp: {
        productid: parseInt(AnalyticsPublic.productid),
        productname: AnalyticsPublic.productname,
        icon: '',
      },
    };
  },
  methods: {
    setProductObj(pObj, isChange) {
      this.selectedApp = pObj;

      this.$store.commit('setProductObj', pObj);

      if (isChange) {
        setTimeout(() => {
          const tmpObj = {
            productid: '' + pObj.productid,
            productname: pObj.productname,
            registertime: pObj.registertime,
            authorized: pObj.authorized,
            watchshow: pObj.watchshow,
            platformFull: pObj.platform,
            platform: pObj.platform,
          };

          BaseLib.postMessage('msg-change-product', pObj);
          StateHandler.savePublic(tmpObj);
          this.$emit('gob-change-product', pObj);
          this.$emit('gob-change-any', 'product');
        });
      } else {
        this.$emit('gob-init-product', pObj);
      }
    },

    selectApp(index) {
      if (this.productList[index].productid === this.selectedApp.productid) return;

      this.setProductObj(this.productList[index], true);
    },
    fetchList() {
      let prodList = this.$store.state.productList;
      if (this.ownProduct) {
        prodList = this.$store.state.productOwnList;
      }
      this.productList = prodList || [];
      this.renderProduct();
    },
    renderProduct() {
      const tmpObj = this.productList.find((item) => {
        return item.productid === parseInt(AnalyticsPublic.productid);
      });
      if (tmpObj) {
        this.setProductObj(tmpObj);
      }
    },
    trim(s) {
      return s.replace(/(^\s*)|(\s*$)/g, '');
    },
  },
  beforeCreate() {
    StateHandler.loadPublic();
  },
  mounted() {
    this.fetchList();
  },
};
</script>

<style scoped>
/* 外层盒子样式 */
.filter-left {
  display: flex;
  height: 56px;
  padding: 10px 12px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);

  position: relative;
  width: 100%;
  background-color: #ffffff;
  z-index: 9;
}

/* app样式 */
.filter-content {
  padding: 0 8px;
}

.filter-content .ivu-btn {
  padding: 0 0 2px 5px;
}

.filter-appselecter {
  width: 167px;
}

.filter-appselecter-ctrl .filter-appselecter img,
.filter-appselecter-item .filter-appselecter img,
.filter-appselecter .app-icon,
.filter-appselecter .filter-appselecter-ctrl img,
.filter-appselecter .filter-appselecter-item img {
  border-radius: 50%;
  width: 28px;
  height: 28px;
  position: absolute;
  top: 3px;
  left: 3px;
}

.filter-appselecter-ctrl span .filter-appselecter span,
.filter-appselecter-item .filter-appselecter span,
.filter-appselecter .filter-appselecter-ctrl span span,
.filter-appselecter .filter-appselecter-item span,
.filter-appselecter .text-ellipsis {
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.filter-appselecter-ctrl {
  position: relative;
  width: 100%;
  height: 36px;
  padding-right: 12px !important;
}

.filter-appselecter-ctrl > span {
  width: 100%;
}

.filter-appselecter-ctrl span span {
  margin-left: 20px;
  float: left;
  width: 99px;
  text-align: left;
  color: #464c5b;
  font-weight: 700;
}

.filter-appselecter-ctrl span i {
  float: right;
  padding: 4px 0;
}

.filter-appselecter-list {
  max-height: 320px;
  overflow-y: auto;
}

.filter-appselecter-item {
  position: relative;
}

.filter-appselecter-item.ivu-dropdown-item {
  padding-bottom: 10px;
  margin-bottom: 5px;
}

.filter-appselecter-item span {
  margin-left: 16px;
  width: 100%;
}
</style>
